import React from 'react';
import ActionButton from '@/components/ui/ActionButton';
interface ActionButtonsProps {
  onApprove?: () => void;
  onReject?: () => void;
  onDelete?: () => void;
  isDeleting?: boolean;
  isAdmin?: boolean;
  showApproveReject?: boolean;
  showDelete?: boolean;
}

/**
 * ActionButtons - Reusable action buttons component
 * 
 * Renders appropriate action buttons based on context (approve/reject, delete).
 * Handles loading states and admin protection logic.
 */
const ActionButtons: React.FC<ActionButtonsProps> = ({
  onApprove,
  onReject,
  onDelete,
  isDeleting = false,
  isAdmin = false,
  showApproveReject = false,
  showDelete = false
}) => {
  if (showApproveReject && onApprove && onReject) {
    return (
      <div className="flex items-center space-x-2">
        <ActionButton
          variant="success"
          size="sm"
          onClick={onApprove}
          className="hover:shadow-md transition-shadow"
        >
          <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
          Approve
        </ActionButton>
        <ActionButton
          variant="danger"
          size="sm"
          onClick={onReject}
          className="hover:shadow-md transition-shadow"
        >
          <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
          Reject
        </ActionButton>
      </div>
    );
  }

  if (showDelete && onDelete) {
    if (isAdmin) {
      return <span className="text-xs text-gray-400 italic">Protected User</span>;
    }

    return (
      <ActionButton
        variant="danger"
        size="sm"
        onClick={onDelete}
        disabled={isDeleting}
        className="hover:shadow-md transition-colors"
      >
        {isDeleting ? (
          <>
            <svg className="animate-spin -ml-1 mr-1 h-3 w-3 text-red-700" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Deleting...
          </>
        ) : (
          <>
            <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
            Delete
          </>
        )}
      </ActionButton>
    );
  }

  return null;
};

export default ActionButtons;
